import Topbar from './Topbar'
import CollectionWorkflowModal from '../modals/CollectionWorkflowModal'
import MapView from '../map/MapView'
import ToastStack from '../ui/ToastStack'
import { useMapSettings } from '../../api/settings'

export default function AppShell() {
  // Bootstrap persisted map settings (including WMS) on authenticated app load.
  useMapSettings()

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-background">
      <Topbar />
      {/* Map fills remaining viewport */}
      <main className="flex-1 relative overflow-hidden">
        <MapView />
        <CollectionWorkflowModal />
      </main>
      <ToastStack />
    </div>
  )
}
